<h1 mat-dialog-title width="100%" style="display:flex ; flex-direction: row; justify-content: center;">{{title}}</h1>
<mat-dialog-content>
  <h4>{{description}}</h4>
  <h6>{{subtext}}</h6>
</mat-dialog-content>
<div mat-dialog-actions width="100%" style="display:flex ; flex-direction: row-reverse;">
  <button mat-button (click)="onYesClick()">{{confirmText}}</button>
  <button *ngIf="data.showCancelButton == true" mat-button (click)="onNoClick()">{{cancelText}}</button>
</div>
